import { render, staticRenderFns } from "./bodyLeftCenter.vue?vue&type=template&id=7910d4d6&scoped=true"
import script from "./bodyLeftCenter.vue?vue&type=script&lang=js"
export * from "./bodyLeftCenter.vue?vue&type=script&lang=js"
import style0 from "./bodyLeftCenter.vue?vue&type=style&index=0&id=7910d4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7910d4d6",
  null
  
)

export default component.exports